export default __webpack_public_path__ + "static/media/download.76ba6b32.svg";